import React from 'react';
import ModalTitle from '../modal-title';
import FiltersPopupActionButtons from '../filters-popup-action-buttons';
import GigsFiltersPopupCanvas from './GigsFiltersPopupCanvas';
import Modal from '@/components/modal';
import {FilterState} from '@/stores/gigsStore';
import {VerticalTag} from '@/types/verticalTag';

export interface GigsFiltersPopupProps {
  isOpen: boolean;
  onClose: () => void;
  filters: FilterState;
  onFilterChange: (key: keyof FilterState, value: any) => void;
  onApplyFilters: () => void;
  onResetFilters: () => void;
  filterResultsCount: number | null;
  isCountLoading: boolean;
  verticalTags: VerticalTag[];
  isLoadingVerticalTags: boolean;
}

function GigsFiltersPopup({
  isOpen,
  onClose,
  filters,
  onFilterChange,
  onApplyFilters,
  onResetFilters,
  filterResultsCount,
  isCountLoading,
  verticalTags,
  isLoadingVerticalTags,
}: GigsFiltersPopupProps) {
  return (
    <Modal
      dividers
      open={isOpen}
      scroll="paper"
      onClose={onClose}
      actions={
        <FiltersPopupActionButtons
          resultCount={filterResultsCount}
          isLoadingCount={isCountLoading}
          onApplyClick={onApplyFilters}
          onResetClick={onResetFilters}
        />
      }
      title={<ModalTitle title="Filters" onCloseButtonClick={onClose} />}
    >
      <GigsFiltersPopupCanvas
        updateFilters={onFilterChange}
        filters={filters}
        verticalTags={verticalTags}
        isLoadingVerticalTags={isLoadingVerticalTags}
      />
    </Modal>
  );
}

export default GigsFiltersPopup;
